// extracted by mini-css-extract-plugin
export default {"cls1":"DY2awOv45VZDEEXG6fYm","cls2":"V7inoac8uSm8_A15Nsgf DY2awOv45VZDEEXG6fYm","isPhone":"YK2DBc7cmmflXCPnCQPT"};